import { takeLeading, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/tags/actions';
import tagsApi from 'src/services/api/tags';
import toaster from 'src/services/toaster';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* create(action: any) {
  try {
    const response = yield call(tagsApi.create, action.tag);
    yield put(Creators.tagsCreateRequestSuccess(response));
    toaster.success('Tag were added successfully');
  } catch (e) {
    DBErrorMonitor.captureException(e, { saga: 'create', entity: 'Tags' });
    toaster.error(e.message);
    let error = e.response;
    yield put(Creators.tagsCreateRequestError(error));
  }
}

export function* watchCreate() {
  yield takeLeading(Types.TAGS_CREATE_REQUEST, create);
}

export default watchCreate;
